import { Injectable } from '@angular/core';
import type { PaginationQueryInterface } from '@zaoblako/shared/common/dtos/pagination-query.dto';
import type { PlannedIncomeHistoryPageInterface } from '@zaoblako/shared/modules/task/dtos/planned-income-history/planned-income-history-page.dto';
import { PlannedIncomeBindDocumentsInterface } from '@zaoblako/shared/modules/task/dtos/planned-income/planned-income-bind-documents.dto';
import { PlannedIncomePageInterface } from '@zaoblako/shared/modules/task/dtos/planned-income/planned-income-page.dto';
import { PlannedIncomeQueryInterface } from '@zaoblako/shared/modules/task/dtos/planned-income/planned-income-query.dto';
import { PlannedIncomeSubtotalFindInterface } from '@zaoblako/shared/modules/task/dtos/planned-income/planned-income-subtotal-find.dto';
import { PlannedIncomeSubtotalQueryInterface } from '@zaoblako/shared/modules/task/dtos/planned-income/planned-income-subtotal-query.dto';
import { PlannedIncomeTotalAmountFindInterface } from '@zaoblako/shared/modules/task/dtos/planned-income/planned-income-total-amount-find.dto';
import { PlannedIncomeTotalAmountQueryInterface } from '@zaoblako/shared/modules/task/dtos/planned-income/planned-income-total-amount-query.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PlannedIncomeService extends BaseService {
  protected baseUrl = '/finance/brs/payment-calendar/planned-income';

  public findWithPagination(queryParams: PlannedIncomeQueryInterface): Observable<PlannedIncomePageInterface> {
    return this.http.get<PlannedIncomePageInterface>(`${this.baseUrl}`, {
      params: this.objectToHttpParams(queryParams)
    });
  }

  public getHistory(id: number, queryParams?: PaginationQueryInterface): Observable<PlannedIncomeHistoryPageInterface> {
    return this.http.get<PlannedIncomeHistoryPageInterface>(`${this.baseUrl}/${id}/history`, {
      params: queryParams ? this.objectToHttpParams(queryParams) : {}
    });
  }

  public setIncomesReceivedForOne(id: number): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/${id}/set-incomes-received`, null);
  }

  public dropIncomesReceivedForOne(id: number): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/${id}/drop-incomes-received`, null);
  }

  public bindDocumentsToOne(id: number, body: PlannedIncomeBindDocumentsInterface): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/${id}/bind-documents`, body);
  }

  public getTotalAmounts(
    queryParams: PlannedIncomeTotalAmountQueryInterface
  ): Observable<PlannedIncomeTotalAmountFindInterface> {
    return this.http.get<PlannedIncomeTotalAmountFindInterface>(`${this.baseUrl}/total-amounts`, {
      params: this.objectToHttpParams(queryParams)
    });
  }

  public getSubtotals(
    queryParams: PlannedIncomeSubtotalQueryInterface
  ): Observable<PlannedIncomeSubtotalFindInterface[]> {
    return this.http.get<PlannedIncomeSubtotalFindInterface[]>(`${this.baseUrl}/subtotals`, {
      params: this.objectToHttpParams(queryParams)
    });
  }
}
